import { render, staticRenderFns } from "./OccupationskillsModifiedByUserWidget.vue?vue&type=template&id=4de6bdb4"
import script from "./OccupationskillsModifiedByUserWidget.vue?vue&type=script&lang=js"
export * from "./OccupationskillsModifiedByUserWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de6bdb4')) {
      api.createRecord('4de6bdb4', component.options)
    } else {
      api.reload('4de6bdb4', component.options)
    }
    module.hot.accept("./OccupationskillsModifiedByUserWidget.vue?vue&type=template&id=4de6bdb4", function () {
      api.rerender('4de6bdb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/OccupationskillsModifiedByUserWidget.vue"
export default component.exports